import module from './module.js'
/* Components */
import './components/herramientas/components.js'

export default module.name



// WEBPACK FOOTER //
// ./src/dashboard/index.js